module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Sgombraneve_in_Azione-BN-CL.40938128.svg";